import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const CARDS = [
  {
    icon: 'fa-crosshairs',
    title: 'Quantum Threat Intelligence',
    desc: "We map your assets cryptographic profile against Shor's Algorithm and Grover's Algorithm — the two primary quantum attacks targeting public-key and symmetric cryptography.",
  },
  {
    icon: 'fa-exclamation-triangle',
    title: 'Vulnerability Detection',
    desc: 'Instantly flag RSA, ECDSA, and DSA key algorithms that become trivially breakable once a cryptographically-relevant quantum computer (CRQC) reaches operational scale.',
  },
  {
    icon: 'fa-sitemap',
    title: 'Certificate Chain Analysis',
    desc: 'Full TLS handshake inspection — key size, hash algorithm, cipher suite, TLS version, issuer, expiry — giving you a complete cryptographic health picture in one scan.',
  },
  {
    icon: 'fa-road',
    title: 'PQC Migration Roadmap',
    desc: "Receive a step-by-step NIST-aligned migration plan covering ML-KEM (FIPS 203), ML-DSA (FIPS 204), and hybrid-mode deployment — tailored to your certificate's specific risk profile.",
  },
];

const QuantomeFeatures = () => {
  const [hovered, setHovered] = useState(null);

  useEffect(() => { AOS.init({ duration: 1200 }); }, []);


  return (
    <div style={S.section}>
      <div style={S.container} data-aos="fade-up">

        {/* heading */}
        <div style={S.titleWrap}>
          <h2 style={S.title}>Key Capabilities</h2>
          <p style={S.subtitle}>
            Everything you need to assess, understand, and act on your quantum security posture.
          </p>
        </div>

        {/* 4-column grid */}
        <div style={S.grid} className="qfeat-grid">
          {CARDS.map(({ icon, gif, title, desc }, i) => (
            <div
              key={title}
              data-aos="fade-up"
              data-aos-delay={i * 100}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                ...S.card,
                transform: hovered === i ? 'translateY(-6px)' : 'translateY(0)',
                boxShadow: hovered === i
                  ? '0 8px 32px rgba(30,64,175,0.14)'
                  : '0 1px 4px rgba(0,0,0,0.07)',
              }}
            >
              <div style={S.iconWrap}>
                <i className={`fa ${icon}`} style={S.icon} />
              </div>

              <h3 style={S.cardTitle}>{title}</h3>
              <p style={S.cardDesc}>{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const S = {
  section: {
    padding: '80px 20px',
    background: '#fff',
    overflow: 'hidden',
  },
  container: {
    maxWidth: 1100,
    margin: '0 auto',
  },
  titleWrap: {
    textAlign: 'center',
    marginBottom: 48,
  },
  title: {
    fontSize: 'clamp(24px,3vw,34px)',
    fontWeight: 800,
    color: '#0f172a',
    margin: '0 0 12px',
  },
  subtitle: {
    color: '#64748b',
    fontSize: 16,
    margin: 0,
    maxWidth: 520,
    marginLeft: 'auto',
    marginRight: 'auto',
    lineHeight: 1.6,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 24,
  },
  card: {
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: 16,
    padding: '28px 22px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    cursor: 'default',
  },
  iconWrap: {
    width: 90,
    height: 90,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 18,
    flexShrink: 0,
  },
  icon: {
    fontSize: 38,
    color: '#1e40af',
  },
  gif: {
    width: 80,
    height: 80,
    borderRadius: 14,
    objectFit: 'cover',
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: '#1e293b',
    margin: '0 0 10px',
    lineHeight: 1.3,
  },
  cardDesc: {
    fontSize: 13.5,
    color: '#64748b',
    lineHeight: 1.65,
    margin: 0,
    textAlign: 'left',
  },
};

export default QuantomeFeatures;
